export default __webpack_public_path__ + "static/media/dataLeakage.f04d7e6c.png";